import React from 'react';

export const CuripodAISolidStarsSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="32"
    height="29"
    viewBox="0 0 32 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.895 11.6128C17.3257 9.53151 17.9955 0.566697 17.9955 0.566697C17.9955 0.566697 17.8187 8.938 20.5117 11.7644C22.758 14.1223 28.0733 13.9156 29.1188 13.8502C29.2356 13.8411 29.299 13.8374 29.299 13.8374C29.299 13.8374 29.2354 13.8429 29.1188 13.8502C28.082 13.9318 22.8413 14.4513 20.4061 16.7527C17.6969 19.3136 17.4093 28.318 17.4093 28.318C17.4093 28.318 17.3032 19.7669 14.7896 16.6012C12.9173 14.2433 8.80375 13.5044 7.08991 13.2938C6.60722 13.2579 6.3166 13.2172 6.3166 13.2172C6.3166 13.2172 6.60853 13.2346 7.08991 13.2938C8.75616 13.4176 12.7105 13.4833 14.895 11.6128Z"
      fill="currentColor"
    />
    <path
      d="M11.103 24.1696C11.566 23.7674 11.5493 22.2254 11.5493 22.2254C11.5493 22.2254 11.6569 23.6567 12.258 24.0864C12.7595 24.4449 13.8466 24.3064 14.06 24.2749C14.0838 24.2711 14.0968 24.2693 14.0968 24.2693C14.0968 24.2693 14.0839 24.2715 14.06 24.2749C13.8487 24.3091 12.7822 24.4994 12.3221 24.9393C11.8103 25.4286 11.906 26.9699 11.906 26.9699C11.906 26.9699 11.7373 25.5136 11.1671 25.0224C10.7424 24.6567 9.88561 24.6106 9.5303 24.6079C9.4307 24.6111 9.37035 24.6099 9.37035 24.6099C9.37035 24.6099 9.43054 24.6072 9.5303 24.6079C9.87431 24.5967 10.6868 24.5311 11.103 24.1696Z"
      fill="currentColor"
    />
    <path
      d="M6.56266 19.6636C5.67992 20.5723 5.71682 24.1283 5.71682 24.1283C5.71682 24.1283 5.50648 20.8241 4.35711 19.8091C3.39816 18.9623 1.32255 19.238 0.915175 19.3019C0.869667 19.3098 0.845028 19.3136 0.845028 19.3136C0.845028 19.3136 0.869617 19.3091 0.915175 19.3019C1.31866 19.2319 3.35456 18.8358 4.23167 17.8402C5.20772 16.7324 5.01964 13.1747 5.01964 13.1747C5.01964 13.1747 5.34673 16.5394 6.43737 17.6947C7.24958 18.5551 8.88605 18.6959 9.5645 18.7162C9.75485 18.7127 9.87008 18.7181 9.87008 18.7181C9.87008 18.7181 9.75509 18.7219 9.5645 18.7162C8.90749 18.7283 7.35613 18.8469 6.56266 19.6636Z"
      fill="currentColor"
    />
  </svg>
);

export default CuripodAISolidStarsSvg;
